/** Display label per statement kind, for the read-only and parse-error views. */
import type { StatementInfo } from '../../../../sql-grammar/model';

export const STATEMENT_KIND_LABELS: Partial<Record<StatementInfo['kind'], string>> = {
  'ddl-create': 'CREATE',
  'ddl-alter': 'ALTER',
  'ddl-drop': 'DROP',
  'ddl-truncate': 'TRUNCATE',
  'ddl-rename': 'RENAME',
  grant: 'GRANT',
  revoke: 'REVOKE',
  'transaction-control': 'transaction',
  'session-setting': 'session',
  explain: 'EXPLAIN',
  call: 'CALL',
  'procedural-body': 'procedural body',
  pragma: 'PRAGMA',
  'batch-separator': 'batch separator',
  'client-directive': 'client directive',
  unknown: 'unknown',
  select: 'SELECT',
  insert: 'INSERT',
  update: 'UPDATE',
  delete: 'DELETE',
  merge: 'MERGE',
};
